import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <a
      href="https://wa.me/51924654344?text=Hola Equipo Voila Consulting, tengo unas consultas, si me podrian ayudar por favor."
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp"
      title="Chatea en WhatsApp"
    >
      <img
        src={require(`./pages/img/whatsapp.png`)}
        alt="WhatsApp"
        className="whatsapp-picture"
      />
      <span className="whatsapp-tooltip">¿Alguna consulta? Escribenos</span>
    </a>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
